import $ from "jquery";

window.passedCaptcha = function () {
    submitSendEmail(document.getElementsByName('smart-token')[0].value);
}

$(document).ready(function () {
    $('#name').on('blur',function (e){
        const elem = e.currentTarget;
        validateElem(elem);
    })

    $('#tel_or_email').on('blur',function (e){
        const elem = e.currentTarget;
        validateElem(elem);
    })

    $('#to_form').click(function (e){
        e.preventDefault();

        $('html, body').animate({
            scrollTop: $('#form_camp').offset().top
        }, 500);
    })

    $(`#send_form_camp`).submit(function (e) {
        e.preventDefault();
        if (!window.smartCaptcha) {
            return false;
        }
        window.smartCaptcha.execute();
        return true;
    });

    function indicateError(indicate, errorElement) {
        if (indicate) {
            $(errorElement).closest('.mtui-text-field__wrapper').addClass('mtui-text-field_error');
        } else {
            $(errorElement).closest('.mtui-text-field__wrapper').removeClass('mtui-text-field_error');
        }
        return !indicate;
    }

    function validateElem(elem) {
        const res = elem.value.trim() === '';
        return indicateError(res, elem);
    }

    window.submitSendEmail = (token) => {
        if (validateElem($('#name').get(0)) &&
            validateElem($('#tel_or_email').get(0))) {
            sendEmail(token);
            return true;
        } else {
            return false;
        }
    }

    function sendEmail(token){
        $.ajax({
            type: 'POST',
            url: '/send_mail_new_user',
            data: {
                captcha_token: token,
                name: $('#name').val(),
                tel_or_email: $('#tel_or_email').val(),
                about_camp: $('#about_camp').val(),
                website_type: window.website_type,
            },
            dataType: 'json',
            success: function () {
                $('#success_window').removeClass('message-hidden');
                setTimeout(function() {
                    $('#success_window').addClass('message-hidden');
                },5000);
            },
            error: function () {
                $('#error_window').removeClass('message-hidden');
                setTimeout(function() {
                    $('#error_window').addClass('message-hidden');
                },5000);
            },
            complete: function() {
                $('#send_form_camp')[0].reset();
            }
        });
    }
});
